import { jsx as _jsx } from "react/jsx-runtime";
import HubspotWrapper from './HubspotWrapper';
import UISpinner from '../UIComponents/UISpinner';
import { pluginPath } from '../../constants/leadinConfig';
export default function LoadingBlock() {
    return (_jsx(HubspotWrapper, { pluginPath: pluginPath, children: _jsx(UISpinner, { size: 50 }) }));
}
